import store from '../state/store';
import config from '../config';
import { IAssetInfo } from '../interfaces/Assets';

export default class AssetUtility
{
	private static jwtToken: string | undefined;

	static setJwtToken(jwtToken: string): void
	{
		this.jwtToken = jwtToken;
	}

	static getRawAssetURL(assetId: string): string
	{
		return config.SERVER_ADDRESS + config.DOWNLOAD_FILE_PATH + '?state=preview&asset=' + assetId +
			'&jwt=' + this.jwtToken;
	}

	static getPreviewAssetURL(assetId: string): string
	{
		if(!assetId) return "";
		return AssetUtility.getRawAssetURL(assetId); //fallback to raw asset url if preview asset doesn't exist
	}

	static getProcessedAssetURL(assetId: string): string
	{
		return config.SERVER_ADDRESS + config.DOWNLOAD_FILE_PATH + '?state=processed&asset=' + assetId +
			'&jwt=' + this.jwtToken;
	}

	static getAssetName(assetId: string): string | undefined
	{
		if(!assetId) return "";
		
		const library = store.getState().assetModule.library;
		const project = store.getState().assetModule.project;
		const materials = store.getState().materialsModule.materials;
		const slides = store.getState().uiModule.slideMaster;
		const visage = store.getState().visageModule.uiTemplateData;
		const foreign = store.getState().assetModule.foreign;

		if (project && project[assetId])
		{
			return project[assetId]['name'];
		}
		else if (library && library.user[assetId])
		{
			return library.user[assetId]['name'];
		}
		else if (library && library.organization[assetId])
		{
			return library.organization[assetId]['name'];
		}
		else if (materials && materials[assetId])
		{
			return materials[assetId]['name']['value'];
		}
		else if (slides && slides[assetId])
		{
			return slides[assetId]['name'];
		}
		else if (visage && visage[assetId])
		{
			return visage[assetId]['name'];
		}
		else if (foreign && foreign[assetId])
		{
			return foreign[assetId]['name'];
		}

		if (library)
		{
			//If we got here, the asset id doesn't exist or it's acutally a revision id
			for (const asset of Object.values<IAssetInfo>(library.user))
			{
				if (asset.revisions)
				{
					for (const revision of asset.revisions)
					{
						if (revision.id === assetId)
						{
							return revision.name;
						}
					}
				}
			}
			for (const asset of Object.values<any>(library.organization))
			{
				if (asset.revisions)
				{
					for (const revision of asset.revisions)
					{
						if (revision.id === assetId)
						{
							return revision.name;
						}
					}
				}
			}
		}

		return "";
	}
}
